export default __webpack_public_path__ + "static/media/bg5.3d6af79f.png";